import { withTheme } from "@mui/styles";
import LoginContainer from "./LoginContainer";
import LoginStore from "./LoginStore";

export default LoginStore(withTheme(LoginContainer));